import { HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Entity, FieldMetadataUtil, FrameContext, Repository } from '@farris/devkit';
import { ResponseInfo, BefRepository } from '@farris/bef';

/**
 * è·¯å¾æ ä»åº
 */
class PathTreeRepository {

  /**
   * æ·»å åå¼èç¹
   */
  public addSibling(repository: BefRepository<Entity>, id: string): Observable<Entity> {
    const restService = repository.restService;
    const baseUri = restService.baseUri;
    const addSiblingUri = `${baseUri}/service/pathhierarchycreatesibling`;
    const body = {
      dataID: id,
      requestInfo: restService.buildRequestInfo()
    };
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: body
    };
    return restService.invoke(addSiblingUri, 'PUT', null, options).pipe(
      map((responseInfo: ResponseInfo) => {
        const entity = repository.buildEntity(responseInfo.returnValue);
        repository.entityCollection.addEntity(entity);
        return entity;
      })
    );
  }

  /**
   * æ·»å åå¼èç¹
   */
  public addChild(repository: BefRepository<Entity>, parentId: string) {
    const restService = repository.restService;
    const baseUri = restService.baseUri;
    const addChildUri = `${baseUri}/service/pathhierarchycreatechildlayer`;

    const body = {
      dataID: parentId,
      requestInfo: restService.buildRequestInfo()
    };
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: body
    };
    return restService.invoke(addChildUri, 'PUT', null, options).pipe(
      map((responseInfo: ResponseInfo) => {
        const entity = repository.buildEntity(responseInfo.returnValue);
        repository.entityCollection.addEntity(entity);
        return entity;
      })
    );
  }

  /**
   * æ·»å å­è¡¨åå¼èç¹
   */
  public addSubSibling(repository: BefRepository<Entity>, nodes: Array<string>, ids: Array<string>): Observable<Entity> {
    const restService = repository.restService;
    const baseUri = restService.baseUri;
    const addSubSiblingUri = `${baseUri}/service/childnodepathhierarchycreatesibling`;
    const body = {
      nodes: nodes,
      ids: ids,
      requestInfo: restService.buildRequestInfo()
    };
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: body
    };
    return restService.invoke(addSubSiblingUri, 'PUT', null, options).pipe(
      map((responseInfo: ResponseInfo) => {
        let path = this.getPaths(nodes, ids);
        const entity = repository.entityManager.appendEntityByPath(path, responseInfo.returnValue)
        return entity;
      })
    );
  }

  /**
  * æ·»å å­è¡¨å­èç¹
  */
  public addSubChild(repository: BefRepository<Entity>, nodes: Array<string>, ids: Array<string>) {
    const restService = repository.restService;
    const baseUri = restService.baseUri;
    const addSubChildUri = `${baseUri}/service/childnodepathhierarchycreatechildlayer`;

    const body = {
      nodes: nodes,
      ids: ids,
      requestInfo: restService.buildRequestInfo()
    };
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: body
    };
    return restService.invoke(addSubChildUri, 'PUT', null, options).pipe(
      map((responseInfo: ResponseInfo) => {
        let path = this.getPaths(nodes, ids);
        const entity = repository.entityManager.appendEntityByPath(path, responseInfo.returnValue)
        return entity;
      })
    );
  }

  private getPaths(nodes: string[], ids: string[]) {
    let paths = '';
    if (nodes && nodes.length > 0 && ids && ids.length > 0) {
      for (let i = 0; i < ids.length; i++) {
        if (nodes[i]) {
          paths = paths + `/${ids[i]}`;
          paths = paths + `/${nodes[i]}s`;
        }
      }
    }
    return paths;
  }

  /**
   * å è½½ç¶èç¹
   */
  // tslint:disable-next-line: max-line-length
  public loadByParentId(repository: BefRepository<Entity>, hierarchyInfoKey: string, parentId: string, filters: any[], sorts: any[], frozenCurrentRow: boolean = false, pagination?: { pageSize: number, pageIndex: number }, frameContext?: FrameContext, reload: boolean = false): Observable<Entity[]> {
    const localEntities = this.getChildren(repository, hierarchyInfoKey, parentId);
    if (localEntities && localEntities.length > 0 && !reload) {
      return of(localEntities);
    }
    const restService = repository.restService;
    const parentHierarchyInfo = this.getHierarchyInfoById(repository, hierarchyInfoKey, parentId);
    const originalHierarchyInfoKey = this.getOriginalHierarchyInfoKey(repository, hierarchyInfoKey);
    const filtersWithParent = this.buildFiltersWithParent(originalHierarchyInfoKey, parentHierarchyInfo, filters);
    const isUsePagination = pagination && pagination.pageSize > 0 || false;
    // ç»ç»EntityFilter
    const entityFilter = {
      FilterConditions: filtersWithParent,
      SortConditions: sorts,
      IsUsePagination: isUsePagination,
      Pagination: { PageIndex: pagination && pagination.pageIndex || 0, PageSize: pagination && pagination.pageSize || 0, PageCount: 0, TotalCount: 0 }
    };
    const requestInfo = restService.buildRequestInfo();
    return restService.extendQuery(entityFilter, requestInfo).pipe(
      map((responseInfo: ResponseInfo) => {
        const paginationInfo = this.getPaginationInfo(responseInfo);
        if (parentId) {
          if (paginationInfo && paginationInfo.pageSize !== 0 && frameContext) {
            frameContext.params.set(`_NODE_${parentId}_PAGINATION_INFO_`, paginationInfo);
          }
        } else {
          if (paginationInfo && paginationInfo.pageSize !== 0 && frameContext) {
            frameContext.repository.entityCollection.updatePaginationInfoByPath('/', paginationInfo);
          }
        }
        // åæ¸ç©ºä¸çº§å®ä½
        this.clearDescendantEntities(repository, hierarchyInfoKey, parentHierarchyInfo, frozenCurrentRow);
        // è¿½å ä¸çº§å®ä½
        const listData = responseInfo.returnValue.result;
        const entities = repository.buildEntities(listData);
        if (frozenCurrentRow) {
          repository.entityCollection.addData(entities, { isTreeNodeLoadScene: true });
        } else {
          repository.entityCollection.addEntities(entities, { isTreeNodeLoadScene: true });
        }

        return entities;
      })
    );
  }
  // tslint:disable-next-line: max-line-length
  public loadFullTree(repository: BefRepository<Entity>, hierarchyInfoKey: string, parentId: string, propertyName: string, fullTreeType: string, loadType: string, filters?: any[], context?: any): Observable<Entity[]> {
    const restService = repository.restService;
    const baseUri = restService.baseUri;
    const queryUrl = `${baseUri}/service/parentidfulltreequery`;
    const pathHierarchyInfo = this.getHierarchyInfoById(repository, hierarchyInfoKey, parentId);
    const entityFilter = this.buildEntityFilter(filters, null, 0, 0);
    const body = {
      dataId: parentId || '',
      isUsePagination: false,
      virtualPropertyName: propertyName,
      pagination: {},
      fullTreeType,
      loadType,
      filter: entityFilter,
      requestInfo: restService.buildRequestInfo()
    };
    const options = {
      body: body
    };
    return restService.invoke(queryUrl, 'PUT', null, options).pipe(
      tap((responseInfo: ResponseInfo) => {
        // ä¿å­å±å¼çèç¹
        if (responseInfo.returnValue && responseInfo.returnValue.selectedRowId && context && context.frameContext) {
          const frameContext = context.frameContext as FrameContext;
          const virtualRootFrameContext = frameContext && frameContext.getVirtualRootFrameContext() || null;
          if (virtualRootFrameContext) {
            const list = responseInfo.returnValue.result as any[];
            const selectedRowId = responseInfo.returnValue.selectedRowId;
            // ä»é¡¶å±å¼å§è®¡ç®ææéè¦å±å¼çèç¹
            const leafNodeInfo = list.find((item) => item[repository.primaryKey] === selectedRowId);
            const hierarchyInfo = leafNodeInfo[hierarchyInfoKey] as { isDetail: boolean, layer: number, path: string };
            const ids = this.getAllParentIds(hierarchyInfo, list, hierarchyInfoKey, repository);
            virtualRootFrameContext.params.set('_DEVKIT_expandRowIds', ids.join(','));
            virtualRootFrameContext.params.set('_DEVKIT_selectedRowId', selectedRowId);
            virtualRootFrameContext.uiState.setPropertyValue('__DEVKIT__selectedRow', selectedRowId);
          }
        }
      }),
      map((responseInfo: ResponseInfo) => {
        const frozenCurrentRow: boolean = context && context.frozenCurrentRow || false;
        // åæ¸ç©ºä¸çº§å®ä½
        this.clearDescendantEntities(repository, hierarchyInfoKey, pathHierarchyInfo, frozenCurrentRow);
        // è¿½å ä¸çº§å®ä½
        const listData = responseInfo.returnValue.result;
        const entities = repository.buildEntities(listData);
        if (frozenCurrentRow) {
          repository.entityCollection.addData(entities, {isTreeNodeLoadScene: true});
        } else {
          repository.entityCollection.addEntities(entities, {isTreeNodeLoadScene: true});
        }
        return entities;
      })
    );
  }
  /**
   * æå¥å¯¹ç¶èç¹çè¿æ»¤
   */
  public buildFiltersWithParent(originalHierarchyInfoKey: string, parentHierarchyInfo: any, filterArray: any[]): any {
    const relationType = filterArray && filterArray.length >= 1 ? 1 : 0;

    const parentLayer = parentHierarchyInfo ? parentHierarchyInfo['layer'] : 0;
    const parentFilterArray = [
      {
        "FilterField": `${originalHierarchyInfoKey}.Layer`,
        "Value": parentLayer + 1,
        "Lbracket": null,
        "Rbracket": null,
        "Relation": 1,
        "Expresstype": 0,
        "Compare": 0
      }
    ];

    // ç¶è·¯å¾è¿æ»¤ï¼å¦æä¸ºç©ºï¼åä¸æ·»å ï¼å¼å®¹oracleåæ°ï¼
    const parentPath = parentHierarchyInfo ? parentHierarchyInfo['path'] : '';
    if (parentPath) {
      parentFilterArray.push({
        "FilterField": `${originalHierarchyInfoKey}.Path`,
        "Value": parentPath,
        "Lbracket": null,
        "Rbracket": null,
        "Relation": relationType,
        "Expresstype": 0,
        "Compare": 7
      });
    } else {
      parentFilterArray[0].Relation = relationType;
    }

    return parentFilterArray.concat(filterArray);
  }
  public buildEntityFilter(filter: any[], sort: any[], pageSize: number, pageIndex: number) {

    // @todoï¼ä¸´æ¶å¼å®¹èä»£ç ï¼éä½æ¹å¨å¸¦æ¥çé£é©
    if (!filter && !sort && !pageSize && !pageIndex) {
      return null;
    }
    if (!filter) {
      filter = [];
    }
    if (!sort) {
      sort = [];
    }
    // çº æ­£æåä¸ä¸ªè¿æ»¤æ¡ä»¶çRelation
    if (filter && filter.length > 0) {
      filter[filter.length - 1].Relation = 0;
    }
    const entityFilter = {
      FilterConditions: filter,
      SortConditions: sort,
      IsUsePagination: pageSize === 0 ? false : true,
      Pagination: {
        PageIndex: pageIndex,
        PageSize: pageSize,
        PageCount: 0,
        TotalCount: 0
      }
    };
    return entityFilter;
  }
  /**
   * æ¸ç©ºåä»£å®ä½
   */
  public clearDescendantEntities(repository: BefRepository<Entity>, hierarchyInfokey: string, parentHierarchyInfo: any, frozenCurrentRow: boolean = false): void {

    // æ¸ç©ºæ ¹èç¹
    if (!parentHierarchyInfo) {
      repository.entityCollection.clear();
      return;
    }
    const fPath = parentHierarchyInfo.path;
    const fLayer = parentHierarchyInfo.layer;
    if (frozenCurrentRow) {
      repository.entityCollection.removeData((entity: Entity) => {
        const hierarchyInfo = entity[hierarchyInfokey];
        const path = hierarchyInfo.path;
        const layer = hierarchyInfo.layer;
        return layer > fLayer && path.startsWith(fPath);
      });
    } else {
      repository.entityCollection.removeEntities((entity: Entity) => {
        const hierarchyInfo = entity[hierarchyInfokey];
        const path = hierarchyInfo.path;
        const layer = hierarchyInfo.layer;
        return layer > fLayer && path.startsWith(fPath);
      });
    }

  }

  /**
   * è·åå®ä½çåçº§ä¿¡æ¯
   */
  public getHierarchyInfoById(repository: BefRepository<Entity>, hierarchyInfokey: string, id: string): any {
    if (!id) {
      return null;
    }
    const entity: Entity = repository.entityCollection.getEntityById(id);
    const hierarchyInfoEntity: Entity = entity[hierarchyInfokey];
    return hierarchyInfoEntity.toJSON();
  }

  /**
   * è·ååçº§ç çåå§çå­æ®µå
   */
  public getOriginalHierarchyInfoKey(repository: BefRepository<Entity>, hierarchyInfokey: string): string {
    const ngObjects = FieldMetadataUtil.getNgObjects(repository.entityType);
    const hierarchyInfoNgObject = ngObjects[hierarchyInfokey];
    return hierarchyInfoNgObject.originalDataField as string;
  }
  private getPaginationInfo(responseInfo: ResponseInfo) {
    return responseInfo && responseInfo.returnValue && responseInfo.returnValue.pagination || null;
  }
  private findParent(hierarchyInfo: { isDetail: boolean, layer: number, path: string }, list: any[], hierarchyInfoKey: string) {
    return list.find(item => {
      const currentHierarchyInfo = item[hierarchyInfoKey] as { isDetail: boolean, layer: number, path: string };
      return currentHierarchyInfo.layer === hierarchyInfo.layer - 1 && hierarchyInfo.path.startsWith(currentHierarchyInfo.path);
    });
  }
  private getAllParentIds(hierarchyInfo: { isDetail: boolean, layer: number, path: string }, list: any[], hierarchyInfoKey: string, repository: Repository<any>) {
    let item = this.findParent(hierarchyInfo, list, hierarchyInfoKey);
    const ids = [];
    while (item) {
      ids.push(item[repository.primaryKey]);
      item = this.findParent(item[hierarchyInfoKey], list, hierarchyInfoKey);
    }
    return ids;
  }
  private getHierarchyInfo(entity: Entity, hierarchyInfoKey: string): { path: string, layer: number, isDetail: boolean } {
    return entity[hierarchyInfoKey];
  }
  /**
   * æ¥æ¾èç¹ä¸ææå­çº§ï¼ç¬¬ä¸çº§ï¼
   * @param repository repository
   * @param hierarchyInfoKey åçº§ç å­æ®µ
   * @param id id
   * @returns
   */
  private getChildren(repository: BefRepository<Entity>, hierarchyInfoKey: string, id: string): Entity[] {
    const hierarchyInfo = this.getHierarchyInfoById(repository, hierarchyInfoKey, id);
    if (!hierarchyInfo) {
      return null;
    }
    const layer = hierarchyInfo.layer;
    const path = hierarchyInfo.path;
    const entities: Entity[] = repository.entityCollection.getEntities((entity: Entity) => {
      const hierarchyInfo = this.getHierarchyInfo(entity, hierarchyInfoKey);
      const matched = hierarchyInfo.layer === layer + 1 && hierarchyInfo.path.startsWith(path);
      if (matched) {
        return entity;
      } else {
        return null;
      }
    });
    return entities;
  }
}

export { PathTreeRepository };
